// app/javascript/controllers/theme_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { current: { type: String, default: "classic" } }
  static targets = ["switcher"]

  themes = {
    classic: {
      primary: { light: '#0a5c36', dark: '#07482b' },
      secondary: { light: '#d1e7dd', dark: '#7ec49e' },
      accent: '#d4af37',
      bg: '#f5f0e6'
    },
    modern: {
      primary: { light: '#1e3a8a', dark: '#172554' },
      secondary: { light: '#93c5fd', dark: '#1d4ed8' },
      accent: '#d4af37',
      bg: '#ffffff'
    },
    desert: {
      primary: { light: '#b45309', dark: '#92400e' },
      secondary: { light: '#fef3c7', dark: '#f59e0b' },
      accent: '#c2410c',
      bg: '#ede5d8'
    }
  }

  connect() {
    this.initializeTheme()
  }

  initializeTheme() {
    const savedTheme = localStorage.getItem('theme') || 'classic'
    this.currentValue = savedTheme
    this.applyTheme(savedTheme)
  }

  switch(event) {
    const themeName = event.params.theme
    this.currentValue = themeName
    this.applyTheme(themeName)
    this.savePreference(themeName)
  }

  applyTheme(themeName) {
    const theme = this.themes[themeName] || this.themes.classic
    const root = document.documentElement

    root.style.setProperty('--color-primary-light', theme.primary.light)
    root.style.setProperty('--color-primary-dark', theme.primary.dark)
    root.style.setProperty('--color-secondary-light', theme.secondary.light)
    root.style.setProperty('--color-secondary-dark', theme.secondary.dark)
    root.style.setProperty('--color-accent', theme.accent)
    root.style.setProperty('--color-bg', theme.bg)

    document.documentElement.classList.remove('classic', 'modern', 'desert')
    document.documentElement.classList.add(themeName)
  }

  savePreference(themeName) {
    localStorage.setItem('theme', themeName)

    // If you want to save to server (requires Rails endpoint)
    if (typeof Rails !== 'undefined') {
      Rails.ajax({
        url: '/theme_preferences',
        type: 'PATCH',
        data: new URLSearchParams({ theme: themeName }).toString(),
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'text/javascript'
        }
      })
    }
  }

  get currentTheme() {
    return this.currentValue
  }
}